import { useSnapshot } from 'valtio';
import { useTranslation } from 'react-i18next';

export function useControllerConnectionStatus(controller) {
  const status = useSnapshot(controller).connection?.status;
  const { t } = useTranslation();
  return {
    status,
    disabledReason: status === 'good' ? '' : t('disabled_action_waiting_for_connection')
  };
}
